import type { Node as ProsemirrorNode } from "prosemirror-model";

import { AssetTokenNode } from "@agent-ui/features/chat/components/chat-elements/message-input/AssetTokenNode";
import { serializeChatTokenPayload } from "@agent-ui/features/chat/utils/chatTokenSerialization";
import { mergeAttributes, Node } from "@tiptap/core";

interface MarkdownSerializerState {
  text: (text: string, escape?: boolean) => void;
}

export default Node.create({
  name: "assetComponent",

  group: "inline",

  inline: true,

  selectable: false,
  atom: true,

  parseHTML() {
    return [
      {
        tag: "asset-component",
      },
    ];
  },

  addAttributes() {
    return {
      data: {
        default: null,
        parseHTML: (element) => {
          const dataAttr = element.getAttribute("data");
          if (!dataAttr) {
            return null;
          }
          try {
            return JSON.parse(dataAttr);
          } catch {
            return null;
          }
        },
        renderHTML: (attributes) => {
          if (!attributes.data) {
            return {};
          }
          return {
            data: JSON.stringify(attributes.data),
          };
        },
      },
    };
  },

  renderHTML({ HTMLAttributes }) {
    return ["asset-component", mergeAttributes(HTMLAttributes)];
  },

  addNodeView() {
    return AssetTokenNode;
  },

  addStorage() {
    return {
      markdown: {
        serialize: (state: MarkdownSerializerState, node: ProsemirrorNode) => {
          /*
           * NOTE (Kevin 2025-09-24): Persist asset nodes as <chat-token> so the
           * markdown pipeline can round-trip them into ChatToken components when we
           * render history.
           */
          const token = serializeChatTokenPayload("asset", node.attrs.data);
          if (token) {
            state.text(token, false);
          }
        },
      },
    };
  },
});
